import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from '../../../components/atoms/SVG';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { AddExternalFavoriteForm, AddExternalFavoriteFormProps } from './AddExternalFavoriteForm';
import { Namespace } from '../../../translation/namespace';
import { BlockBar, BlockBarButton } from '../../../_lib/components/BlockBar';

export function AddExternalFavorite({ form }: { form: AddExternalFavoriteFormProps['form'] }) {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { t } = useTranslation(Namespace.FavoritedPages);

  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);
  const addExternalContent = t('addExternalContent');
  return (
    <>
      <BlockBar heading={addExternalContent} hierarchy={3} modifier="border-bottom">
        <BlockBarButton onClick={openModal} text={addExternalContent} svgSpriteId={Icons.ADD_PLUS} />
      </BlockBar>
      {modalOpen && (
        <ModalDialog initialFocusIndex={1} closeModal={closeModal} headline={addExternalContent}>
          <AddExternalFavoriteForm form={form} closeModal={closeModal} />
        </ModalDialog>
      )}
    </>
  );
}
